/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from "react";
import { Button } from "rsuite";
import { Tag } from "@rsuite/icons";
import DeAssignTagsModal from "./DeAssignTagsModal";

interface Props {
    bucketUserWalletKeys: string[];
    bucketId: string | undefined;
    handleModalClose: () => void;
    tags: any;
}

const DeAssignTags = ({
    bucketUserWalletKeys,
    bucketId,
    handleModalClose,
    tags,
}: Props) => {
    const [addTag, setAddTag] = useState(false); // Updated state name

    const [open, setOpen] = useState(false);
    // const [logData, setLogData] = useState<any[]>([]);

    const [props, setProps] = useState<any>([]);

    const handleClose = () => {
        setAddTag(false);
        setOpen(false);
        handleModalClose();
    };

    useEffect(() => {
        // get the accountReference of the selectedRows
        const sub = {
            bucketUserWalletKeys,
            bucketId,
        };
        setProps(sub);
    }, [bucketUserWalletKeys]);

    return (
        <>
            <Button
                appearance="primary"
                className="bg-red-600 py-2 px-4 text-white w-full max-w-[180px] hover:bg-red-500 rounded"
                onClick={() => {
                    setAddTag(true);
                    setOpen(true);
                }} // Updated state function
            >
                <Tag className="mx-2" />
                De-Assign Tag
            </Button>

            {addTag && ( // Updated state reference
                <DeAssignTagsModal
                    tags={tags}
                    open={open}
                    props={props}
                    handleClose={handleClose} // Updated state function
                />
            )}
        </>
    );
};

export default DeAssignTags;
